import { Component } from 'preact';
import s from './style.css';

const styles = [
	{ border: '#FECA98', fill: '#FFF2E6' },
	{ border: '#F1979A', fill: '#F6C1C2' },
	{ border: '#D8AC24', fill: '#FEE077' },
	{ border: '#709EEB', fill: '#C2D6F7' }
];

class LoveHeart extends Component {
	shouldComponentUpdate(nextProps) {
		return this.props.x !== nextProps.x || this.props.y !== nextProps.y;
	}

	render() {
		const {
			text,
			text2,
			x,
			y,
			id,
			style,
			rotation,
			isSmall,
			isSparkle,
			...rest
		} = this.props;
		const colors = styles[style - 1];

		return (
			<div
				{...rest}
				className={s.root}
				style={{
					transform: `translate(${x}px, ${y}px) scale(${isSmall ? 0.75 : 1})`,
					zIndex: isSparkle ? 1 : 2
				}}
			>
				{isSparkle && (
					<svg
						width="16px"
						height="16px"
						viewBox="0 0 8 8"
						className={s.sparkle}
						style={{
							transform: `rotate(${rotation}deg)`,
							animationDelay: `${id * -0.11}s`
						}}
					>
						<use xlinkHref="#sparkle" />
					</svg>
				)}

				{!isSparkle && (
					<svg
						className={s.heart}
						width="70px"
						height="70px"
						style={{
							transform: `rotate(${rotation}deg)`
						}}
					>
						<use
							xlinkHref="#heart"
							style={{
								fill: colors.fill,
								color: colors.border
							}}
						/>
						<text
							font-size="10"
							font-weight="bold"
							text-anchor="middle"
							fill="#333"
						>
							<tspan x="35" y="30">
								{text}
							</tspan>
							<tspan x="35" y="42">
								{text2}
							</tspan>
						</text>
					</svg>
				)}
			</div>
		);
	}
}

export default LoveHeart;



// WEBPACK FOOTER //
// ./components/LoveHeart/index.js